import { render } from "./OrganizationSettings.vue?vue&type=template&id=96f76c72"
import script from "./OrganizationSettings.vue?vue&type=script&lang=js"
export * from "./OrganizationSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/settings/OrganizationSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "96f76c72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('96f76c72', __exports__)) {
    api.reload('96f76c72', __exports__)
  }
  
  module.hot.accept("./OrganizationSettings.vue?vue&type=template&id=96f76c72", () => {
    api.rerender('96f76c72', render)
  })

}


export default __exports__